export default __webpack_public_path__ + "static/media/spy.e6779013.png";